import { addNotification } from "../../../actions";
import { showDialog } from "../../../actions/notifications";
import Icon from "../../../controls/Icon";
import More from "../../../controls/More";
import Toggle from "../../../controls/Toggle";
import { Button } from "../../../controls/TooltipControls";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { showError } from "../../../util/message";
import opn from "../../../util/opn";
import { setAssociatedWithNXMURLs } from "../actions/settings";
import chromeAllowScheme from "../util/chromeAllowScheme";
import { NEXUS_BASE_URL } from "../constants";
import getText from "../texts";
import * as React from "react";
import { Alert, FormGroup, HelpBlock } from "react-bootstrap";
function nop() {
    // nop
}
function DownloadButton() {
    return (React.createElement("div", { className: "nexusmods-action-button" },
        React.createElement(Icon, { id: "nexus-dl-icon", name: "nexus" }),
        React.createElement("a", { className: "nexusmods-fake-link", onClick: nop }, "Mod Manager Download")));
}
class Settings extends ComponentEx {
    mHelpText;
    constructor(props) {
        super(props);
        this.mHelpText = getText("chrome-fix", this.props.t);
    }
    render() {
        const { t, associated } = this.props;
        return (React.createElement("form", null,
            React.createElement(FormGroup, null,
                React.createElement(Toggle, { checked: associated, onToggle: this.associate, disabled: process.platform === "linux" },
                    t("Handle Mod Manager Download buttons on"),
                    " ",
                    React.createElement("a", { onClick: this.openNexus }, "nexusmods.com"),
                    " (nxm:// links)"),
                // on linux this is handled by the desktop environment so you'd have to implement
                // separate solutions for kde, gnome, xfce, ...
                process.platform === "linux" ? (React.createElement(HelpBlock, null,
                    React.createElement(Alert, { bsStyle: "info" }, t("Not supported on Linux")))) : null,
                React.createElement("div", { style: { marginTop: 15 } },
                    t("Fix Nexus Mods links in Chrome " +
                        "(Only required for Chrome. Requires Chrome to be closed)"),
                    React.createElement(More, { id: "more-chrome-fix", name: t("Chrome Fix") }, this.mHelpText),
                    React.createElement(Button, { tooltip: t("Fix"), id: "chrome-download-fix", onClick: this.chromeFix, style: { marginLeft: 5 } }, t("Fix Now"))))));
    }
    openNexus = () => {
        opn(NEXUS_BASE_URL).catch(() => null);
    };
    chromeFix = () => {
        const { onDialog, onShowError } = this.props;
        onDialog("info", "Is Chrome running?", {
            bbcode: "Chrome has to be closed, otherwise this fix has no effect.<br/>" +
                '[color="red"]IMPORTANT: You may have to repeat this step after ' +
                "clearing the cache inside chrome![/color]",
        }, [
            { label: "Cancel" },
            {
                label: "Continue",
                action: () => {
                    chromeAllowScheme("nxm")
                        .then((changed) => {
                        if (changed) {
                            onDialog("success", "Success", {
                                text: "Fix was applied.",
                            }, [{ label: "Close" }]);
                        }
                        else {
                            onDialog("info", "Nothing Changed", {
                                text: "No change was necessary.",
                            }, [{ label: "Close" }]);
                        }
                    })
                        .catch((err) => {
                        if (err.code === "ENOENT") {
                            onShowError("Failed to fix NXM handling in Chrome", "Could not determine the chrome preferences file to fix. " +
                                "Please read the help text for this fix and apply " +
                                "it manually.", { allowReport: false });
                        }
                        else {
                            onShowError("Failed to fix NXM handling in Chrome. ", err, {
                                allowReport: false,
                            });
                        }
                    });
                },
            },
        ]);
    };
    associate = (enabled) => {
        const { onAssociate, onShowInfo } = this.props;
        if (!enabled) {
            onShowInfo("Nexus Mods Links are now unhandled.\n" +
                "To have another application handle those links you have to go to that\n" +
                "application and enable handling of NXM links there.");
        }
        onAssociate(enabled);
    };
}
function mapStateToProps(state) {
    return {
        associated: state.settings.nexus.associateNXM,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onAssociate: (associate) => {
            dispatch(setAssociatedWithNXMURLs(associate));
        },
        onDialog: (type, title, content, actions) => {
            dispatch(showDialog(type, title, content, actions));
        },
        onShowError: (message, details, options) => {
            showError(dispatch, message, details, options);
        },
        onShowInfo: (message) => dispatch(addNotification({
            type: "info",
            message,
        })),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(Settings));
